import { Accordion } from '@/components/common/Accordion';
import { CardsContainer } from '@/components/dashboard/DashboardCard';
import { Benefits } from '@/components/dashboard/supplements/benefit/Benefits';
import { Protocols } from '@/components/dashboard/supplements/protocol/Protocols';
import { Stock } from '@/components/dashboard/supplements/stock/Stock';
import { OurSupplements } from '@/components/dashboard/supplements/supplement/OurSupplements';
import { Supplements } from '@/components/dashboard/supplements/supplement/Supplements';
import { cn } from '@/lib/cn';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { useState } from 'react';

export const SupplementsPage = () => {
  const { isDesktop, isBigDesktop } = useBreakpoint();
  const [accordionValue, setAccordionValue] = useState('');

  return (
    <div className="px-0 py-12.5 md:px-4">
      <CardsContainer
        className={cn(
          'md:rounded-0 pt-8 lg:max-w-305 lg:rounded-3xl xl:w-full',
          isBigDesktop ? 'mx-auto' : isDesktop ? 'mx-2' : 'mx-0',
        )}
      >
        <Accordion
          type="single"
          collapsible
          className="w-full space-y-4 border-none"
          value={accordionValue}
          onValueChange={setAccordionValue}
        >
          <Supplements accordionOpenValue={accordionValue} />
          <Stock accordionOpenValue={accordionValue} />
          <OurSupplements />
          <Benefits />
          <Protocols />
        </Accordion>
      </CardsContainer>
    </div>
  );
};
